import { makeStyles } from "@material-ui/core";
import styled from "styled-components";

import { theme as themeConfig } from "../../themes/themes";
export const FormsContainer = styled.div`
  .MuiFormControlLabel-root {
    margin-right: 0;
  }
  .MuiPaper-root > .MuiToolbar-regular {
    display: none;
  }
  th {
    background-color: ${({ theme }) => theme.neutral.gray[700]};
    padding: 5px 16px;
  }
  tr:nth-child(even) {
    background-color: ${({ theme }) => theme.neutral.gray[200]};
  }
`;

export const ContentTextEllipsis = styled.div`
  overflow: hidden;
  white-space: nowrap;
  width: 130px;
  text-overflow: ellipsis;
`;

export const useStyles = makeStyles(() => ({
  active: {
    "& svg": {
      color: themeConfig.button.primary,
    },
    "&:disabled svg": {
      color: themeConfig.neutral.gray[500],
    },
  },
  delete: {
    color: themeConfig.status.error,
  },
  buttonActive: {
    background: themeConfig.button.primary,
    color: themeConfig.neutral.white,
    height: "29px",
    padding: "3px 10px",
    fontSize: "12px",
  },
  closeModalResumeAnswer: {},
}));
